// The three tiers of audit the system must record evidence for, and the role that
// entitles a user to record each. Kept in one place so the screens, the server-side
// permission check and the reference lists cannot drift apart.
export const auditLevels = [
    { code: "internal", descr: "การตรวจสอบภายใน (Internal Audit)", role: "auditinternal" },
    { code: "external", descr: "การตรวจสอบภายนอก (External Audit)", role: "auditexternal" },
    { code: "independent", descr: "ผู้ตรวจสอบอิสระ/ผู้มีอำนาจอื่น (Independent)", role: "auditindependent" }
]

// What an audit can be recorded against.
export const auditTargets = [
    { code: "chart", descr: "รายการบริการ" },
    { code: "patient", descr: "สมาชิก" },
    { code: "batch", descr: "ชุดข้อมูล/งวด" }
]

export const auditResults = [
    { code: "passed", descr: "ผ่าน" },
    { code: "observation", descr: "มีข้อสังเกต" },
    { code: "failed", descr: "ไม่ผ่าน" }
]

export const auditLevelCodes = auditLevels.map(m => m.code)
export const auditTargetCodes = auditTargets.map(m => m.code)
export const auditResultCodes = auditResults.map(m => m.code)

// Holds at least one audit tier. An auditor sits under an organisation the way a
// caregiver does, so this decides whether the audit menu appears for them - not whether
// they reach the admin area.
export function isauditor(user: any) {
    if (!user || !user.scope) {
        return false
    }
    return auditLevels.some(m => user.scope.includes(m.role))
}

// admin may record at any tier; otherwise the user needs that tier's own role
export function canaudit(user: any, level: any) {
    if (!user || !user.scope) {
        return false
    }
    if (user.scope.includes("admin")) {
        return true
    }
    const lv = auditLevels.find(m => m.code == level)
    return !!(lv && user.scope.includes(lv.role))
}
